import React from 'react';
import LogoHeader from '../layout/LogoHeader';

// A full-page treatment: a floating card (33px radius, deep soft shadow) centred
// on the warm-grey page, with the logo-only header top-left as the way back and
// no dismiss control. Used wherever the app interrupts to say something on its
// own page — auth screens, the plugin login handoff, checkout redirects.
//
// `children` are free-form — put whatever the screen needs in the card. `size`
// picks a preset box; pass `className` to nudge it per screen (appended last, so
// e.g. `md:w-[560px]` widens the card).
//
//  - size="form"   → 350/386px wide, left-aligned groups (login, register, …)
//  - size="notice" → 350/496px wide, centred column, content-height (verify-email,
//                    errors, purchase success)
type Size = 'form' | 'notice';

const CARD: Record<Size, string> = {
    form: 'flex w-[350px] max-w-full flex-col gap-6 rounded-panel bg-surface px-5 pb-7 pt-8 shadow-overlay md:w-[386px]',
    notice: 'flex w-[350px] max-w-full flex-col items-center gap-[26px] rounded-panel bg-surface px-5 py-12 text-center shadow-overlay md:w-[496px]',
};

export function CenteredCardTempScreen({
    size = 'form',
    className = '',
    children,
}: {
    size?: Size;
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <div className="min-h-screen bg-page-warm">
            <LogoHeader />
            <div className="flex min-h-[calc(100vh-theme(spacing.header))] items-center justify-center px-5 py-8">
                <div className={`${CARD[size]} ${className}`}>{children}</div>
            </div>
        </div>
    );
}

// Two stacked lines inside the card: the screen's action over "Organic
// Electronics" ghosted. Used by the auth forms.
export function CenteredCardTempScreenHeading({ action }: { action: string }) {
    return (
        <div className="flex flex-col gap-0.5">
            <span className="text-heading font-bold text-ink">{action}</span>
            <span className="text-heading font-bold text-ink opacity-[0.203]">Organic Electronics</span>
        </div>
    );
}

export default CenteredCardTempScreen;
